import apiService from 'library/api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getSalesStageTypes = createAsyncThunk('getSalesStageTypes', async () => {
  const response = await apiService.getSalesStageTypes();

  return { salesStageTypes: response.data };
});

const salesStageTypesActions = { getSalesStageTypes };

export default salesStageTypesActions;
